/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Beitragsgruppenschluesselkv2Inputs */



/**

* @param {_Field_Beitragsgruppenschluesselkv2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_beitragsgruppenschluesselkv2 = /** @type {((inputs?: _Field_Beitragsgruppenschluesselkv2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Beitragsgruppenschluesselkv2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Beitragsgruppenschlüssel KV")
});
export { _field_beitragsgruppenschluesselkv2 as "_field_beitragsgruppenschluesselKV" }